import {LogoImg, NavigationContainer, NavigationWrapper,NavigationLinks,
	NavigationContacts , NavigationLinksContainer, Phone, SocialLinks} from './navigation.styles'
import Logo  from '../../assets/logo/logo.png';
import Language from '../language/language.component';
import phone from '../../assets/icons/phone.svg'
import telegram from '../../assets/icons/telegram.svg';
import whatsap from '../../assets/icons/whatsapp.svg';
//import viber from '../../assets/icons/viber.svg';
import { Link } from 'react-scroll';
import { setHashUrl } from '../../utils/hashNavigation';
// import { useContext } from 'react';
// import {LanguageContext} from '../../contexts/language.context'
const Navigation =({props})=>{
	// console.log('props', props)
	// const {romanianLanguage} = useContext(LanguageContext);
	return(
		<NavigationWrapper>
			<NavigationContainer>
				<Link className='logoContainer' to="home" spy={true} smooth={true} offset={0} duration={500} onClick={() => setHashUrl("home")}>
					<LogoImg src={Logo} alt='main-logo' className="logo"/>
				</Link>
				<NavigationLinksContainer>
					<NavigationLinks>
						<ul>
							<li className="no-disc"><Language/></li>
							<li><Link to="why-us" spy={true} smooth={true} offset={-150} duration={500} onClick={() => setHashUrl("why-us")}>{props[1]}</Link></li>
							<li><Link to="about-us" spy={true} smooth={true} offset={-150} duration={500} onClick={() => setHashUrl("about-us")}>{props[2]}</Link></li>
							<li><Link to="services" spy={true} smooth={true} offset={-150} duration={500} onClick={() => setHashUrl("services")}>{props[3]}</Link></li>
							<li><Link to="contacts" spy={true} smooth={true} offset={0} duration={500} onClick={() => setHashUrl("contacts")}>{props[4]}</Link></li>
						</ul>
					</NavigationLinks>
					<NavigationContacts>
						<Phone>
							<a href="tel:+393895181415">
								<img src={phone} alt="" />
								<span>+39 389 518 1415</span> 
							</a>
						</Phone>
						<SocialLinks>
							<a href="https://wa.me/+393895181415" ><span className='whatsap'><img src={whatsap} alt="" /></span></a>
							{/* <a href="viber://chat?number=%2B393895181415"><span className='viber'><img src={viber} alt="" /></span></a> */}
							<a href="https://telegram.me/+393895181415"><span className='telega'><img src={telegram} alt="" /></span></a>
							
						</SocialLinks>
					</NavigationContacts>
				</NavigationLinksContainer>
			</NavigationContainer>
		</NavigationWrapper>
	)
}
export default Navigation;